import { render, staticRenderFns } from "./PayWall.vue?vue&type=template&id=b589ff46&"
import script from "./PayWall.vue?vue&type=script&lang=ts&"
export * from "./PayWall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports